import React from 'react';

export function Card({ children, className = '', style = {} }) {
  return (
    <div
      className={`lf-card bg-white rounded-[14px] p-5 ${className}`}
      style={{
        border: '1px solid var(--lf-line)',
        boxShadow: '0 2px 7px rgba(15,23,42,.04)',
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export function CardTitle({ children }) {
  return <h2 className="text-[17px] font-semibold m-0 mb-4">{children}</h2>;
}

export function Metric({ label, value }) {
  return (
    <div
      className="rounded-[10px] p-3.5"
      style={{ background: '#fafbfc', border: '1px solid var(--lf-line)' }}
    >
      <small style={{ color: 'var(--lf-muted)' }} className="text-xs">
        {label}
      </small>
      <strong className="block text-[21px] mt-1 font-bold">{value}</strong>
    </div>
  );
}

export function Tag({ children, variant = 'default' }) {
  const styles = {
    default: { background: '#eef2ff', color: '#3730a3' },
    warning: { background: '#fef3c7', color: '#92400e' },
    success: { background: 'var(--lf-green-bg)', color: 'var(--lf-green)' },
  };
  return (
    <span
      className="text-[11px] font-semibold px-2 py-1 rounded-full"
      style={styles[variant] || styles.default}
    >
      {children}
    </span>
  );
}

export function Button({ variant = 'primary', children, className = '', style = {}, ...props }) {
  const base =
    'inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-sm font-bold cursor-pointer';
  const variants = {
    primary: { background: 'var(--lf-blue)', color: '#fff', border: 'none' },
    secondary: { background: '#eef2f7', color: '#344054', border: 'none' },
  };
  return (
    <button
      {...props}
      className={`${base} ${className}`}
      style={{ ...variants[variant], transition: 'filter 0.15s ease', ...style }}
      onMouseEnter={(e) => (e.currentTarget.style.filter = 'brightness(0.95)')}
      onMouseLeave={(e) => (e.currentTarget.style.filter = 'brightness(1)')}
    >
      {children}
    </button>
  );
}
